import { Form, Card, CardBody } from "react-bootstrap";
import { useForm, FormProvider, useFieldArray } from "react-hook-form";
import { Input, MultiSelect, PageWrapper, Select } from "../../components";
import { useTranslation } from "react-i18next";
import { DriverType, Pages } from '../../shared/enums'
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { createQuiz, updateQuiz } from "../../api/quiz";
import { getQuizDetail } from "../../api/quiz";
import { omit } from "lodash";
import { RiEdit2Fill, RiAddLargeLine } from "react-icons/ri";
import Button from '../../components/common/Button';

const QuizDetail = ({ }) => {
    const optionsName = "options"
    const { t } = useTranslation()
    const navigate = useNavigate()
    const form = useForm({
        defaultValues: {
            isPublish: true
        }
    })
    const { fields, append, remove } = useFieldArray({ control: form.control, name: optionsName });
    const { id } = useParams()
    const [isEdit, setIsEdit] = useState(false)
    const [btnLoading, setBtnLoading] = useState(false)

    useEffect(() => {
        if (id !== "new") {
            setIsEdit(true)
            getData()
        }
    }, [])

    const getData = async () => {
        const response = await getQuizDetail(id)
        form.reset({
            ...omit(response, ['createdAt', 'createdBy', 'updatedAt', 'updatedBy', 'success', 'id']),
            options: response.options.map(option => omit(option, ['createdAt', 'createdBy', 'updatedAt', 'updatedBy', 'quizId'])),
            type: Object.entries(DriverType).map(([key, value]) => ({
                label: t(key),
                value: value
            })).filter(e => response.type.includes(e.value))
        })
    }

    const create = async (data) => {
        setBtnLoading(true)
        const response = await createQuiz({ ...data, type: data.type.map(e => e.value) })
        if (response.success) navigate(Pages.Quiz)
        setBtnLoading(false)
    }

    const update = async (data) => {
        setBtnLoading(true)
        const response = await updateQuiz(id, { ...data, type: data.type.map(e => e.value) })
        if (response.success) navigate(Pages.Quiz)
        setBtnLoading(false)
    }

    return <PageWrapper
        headerProps={{
            title: isEdit ? "EDIT_QUIZ" : "ADD_QUIZ",
            rightElement:
                <Button
                    type="submit"
                    variant="primary"
                    icon={isEdit ? <RiEdit2Fill /> : <RiAddLargeLine />}
                    loading={btnLoading}
                    onClick={() => form.handleSubmit(isEdit ? update : create)()}
                >
                    {t(isEdit ? "UPDATE" : "CREATE")}
                </Button>

        }}
    >
        <FormProvider {...form}>
            <Form>
                <MultiSelect
                    label={t("TYPE")}
                    name={"type"}
                    rules={{ required: t("CANT_BE_EMPTY") }}
                    options={Object.entries(DriverType).map(([key, value]) => ({
                        label: t(key),
                        value: value
                    }))}
                />
                <Input label={t("QUESTION")} name={"question"} rules={{ required: t("QUESTION_IS_REQUIRED") }} />
                <Select label={t("IS_PUBLISH")} name={"isPublish"} rules={{ required: t("IS_PUBLISH_IS_REQUIRED") }} options={[{ label: t("YES"), value: true }, { label: t("NO"), value: false }]} />
                <Button className={"mt-3 mb-3"} onClick={() => append({ optionText: "", isCorrect: false })}>{t("ADD_OPTION")}</Button>
                {
                    fields.map((field, index) =>
                        <Card className={"mb-3"}>
                            <Card.Header>
                                <div className="d-flex align-items-center justify-content-between">
                                    {t("OPTION")} {index + 1}
                                    <Button variant="danger" size="sm" onClick={() => {
                                        remove(index)
                                    }}>
                                        {t("REMOVE")}
                                    </Button>
                                </div>
                            </Card.Header>
                            <CardBody>
                                <Input
                                    key={"optionText" + index}
                                    name={`${optionsName}.${index}.optionText`}
                                    label={t("OPTION_TEXT")}
                                    rules={{ required: t("CANT_BE_EMPTY") }}
                                />
                                <Select
                                    label={t("IS_CORRECT")}
                                    name={`${optionsName}.${index}.isCorrect`}
                                    rules={{
                                        validate: (value) => (!!value || value === false) || t("IS_CORRECT_IS_REQUIRED"),
                                    }}
                                    options={[{ label: t("YES"), value: true }, { label: t("NO"), value: false }]}
                                />
                            </CardBody>
                        </Card>
                    )
                }
            </Form>
        </FormProvider>
    </PageWrapper>
}

export default QuizDetail;